<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'

const props = withDefaults(defineProps<{
  lazy?: boolean
  showCta?: boolean
  products: EsProduct[]
}>(), {
  lazy: true,
  showCta: false,
})

const { $t } = useI18n()

const centerSlides = ref(false)
const navigation = ref(true)
const pagination = ref(false)
const progress = ref(false)
const freescroll = ref(false)

const nextLabel = $t('Next')
const prevLabel = $t('Prev')

const { lazy, showCta } = toRefs(props)
</script>

<template>
  <div class="product-slider">
    <slot />

    <UiCarousel
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': centerSlides,
        'ui-carousel--free-scroll': freescroll,
        'ui-carousel--navigation': navigation,
        'ui-carousel--pagination': pagination,
        'ui-carousel--progress': progress,
      }"
      :next-label="nextLabel"
      :prev-label="prevLabel"
    >
      <template
        v-for="(product, index) in products"
        #[`slide-${index}`]
        :key="index"
      >
        <ProductTile
          :product="product"
          :lazy="lazy || index > 2"
          class="product-slider__product"
          :show-cta="showCta"
        />
      </template>
    </UiCarousel>
  </div>
</template>

<style>
@import url("~layers/app/components/Product/Slider.css");
</style>
